import { ButtonProps } from '@material-ui/core/Button';
import { Button } from './ContainedButton.css';

export default (props: ButtonProps) => {
  const { color = 'primary' } = props;
  return <Button variant="contained" {...props} color={color} />;
};
